// extracted by mini-css-extract-plugin
module.exports = {"cls1":"GetStarted_cls1__ox9CV"};